import React from 'react';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { actions, selectors } from 'redux-store';
import { TiLockClosed as Secure } from 'react-icons/ti';

const Summary = ({ count=0, total=0, saved=0 }) => {

  const format= (a) => numeral(a).format('0,0.00');

  const class_name = (count===0) ? 'hidden' : 'visible';

  const self_checkout = () => window.open('/checkout','_self');

  return (
    <div className={`Summary-Wrapper ${class_name}`}>
    <div className='Cart-Summary'>

      <div className="Summary">
        <div className="Label">Subtotal ({count} item)</div>
        <div className="Value">{format(total)}</div>
      </div>

      <div className="Summary">
        <div className="Label">Shipping</div>
        <div className="Value">{format(0)}</div>
      </div>

      <div className="Summary">
        <div className="Label">Est. total</div>
        <div className="Value">{format(total)}</div>
      </div>

      <div className="Summary">
        <div className="Label">You Save</div>
        <div className="Value">{format(saved)}</div>
      </div>

      <button
        disabled={(count===0)}
        onClick={self_checkout}
        className='Checkout-Button'
        dangerouslySetInnerHTML={{__html: 'Proceed to Checkout'}}
      />

      <div className="Added-Value">

        <div className="Caption">
          <Secure className='Icon'/>
          <span>Secure Shopping</span>
        </div>

        <div className="Description">
          Our checkout meets the current credit card industry’s rigorous PCI security standards. Your privacy is always our number-one priority. Have questions before you check out? Our <span className='link'>Exceptional Customer Service</span> is here to help!
        </div>

      </div>

    </div>
    </div>
  )
}

const mapStateToProps = ({ cart=[] }) => ({
  count: selectors.cart_count(cart),
  total: selectors.cart_total(cart),
  saved: cart.cart_items.reduce((prev,cur) => {
    const price = cur.pricing.price || 0;
    let compare = cur.pricing.compare || 0;
    if (compare===0) compare = price;
    return prev + (cur.quantity * (compare - price));
  }, 0)
});

export default  connect(mapStateToProps,{...actions})(Summary);
